<template>
  <div class="home">
    <section id="homehead">
      <h1 class="maintitle">CREATION<br>DE CONTENU</h1>      
      <p class="maintext">Comme le vent qui vient gonfler les voiles de votre navire, la création de contenu est indispensable pour permettre à votre projet d'avancer et de cibler son public aux quatre coins du globe.</p>
    </section>
    <section id="anchor" class="services__card">
      <anchor-router-link class="services__card__one skewleft" :to="{hash: '#services__offres'}" :scrollOptions="{
                                    container: `body`,
                                    duration: 700,
                                    easing: `ease`,
                                    offset: -100,
                                    cancelable: true,
                                    onStart: false,
                                    onDone: false,
                                    onCancel: false,
                                    x: false,
                                    y: true}">
                                    <div class="services__card__content skewright">
              <i class="fas fa-tasks services__card__icon"></i>
              <h2 class="services__card__title">LES OFFRES</h2></div>
      </anchor-router-link>
      <anchor-router-link class="services__card__one__center skewright" :to="{hash: '#services__process'}" :scrollOptions="{
                                    container: `body`,
                                    duration: 700,
                                    easing: `ease`,
                                    offset: -100,
                                    cancelable: true,
                                    onStart: false,
                                    onDone: false,
                                    onCancel: false,
                                    x: false,
                                    y: true}">
                                    <div class="services__card__content center skewleft">
        <i class="fas fa-cogs services__card__icon"></i>
        <h2 class="services__card__title">LE PROCESS</h2>
        </div>
      </anchor-router-link>
      <anchor-router-link class="services__card__one skewleft" :to="{hash: '#services__price'}" :scrollOptions="{
                                    container: `body`,
                                    duration: 700,
                                    easing: `ease`,
                                    offset: -100,
                                    cancelable: true,
                                    onStart: false,
                                    onDone: false,
                                    onCancel: false,
                                    x: false,
                                    y: true}">
                                    <div class="services__card__content skewright">
        <i class="fas fa-money-bill-wave services__card__icon"></i>
        <h2 class="services__card__title">LES TARIFS</h2>
        </div>
      </anchor-router-link>
    </section>
    <section id="services__offres">
      <h2 class="services__title">LES OFFRES</h2>
      <div class="sticky">
      <img src="../assets/crea.svg" alt="Illustration d'une tablette contenant une personne qui surfe sur une vague de contenus web." class="sticky__img">      
      <Creatext/>
      </div>
      <div class="sticky__no">
        <img src="../assets/crea.svg" alt="Illustration d'une tablette contenant une personne qui surfe sur une vague de contenus web." class="services__offres__img revealleft">
        <div class="services__offres__line revealright">
          <h3 class="services__offres__title">CREATION DE CONTENU</h3>
          <p class="services__offres__text">La création de contenu est une pratique qui consiste à concevoir des supports (photos, vidéos, infographies...) pour les partager sur vos différents médias en ligne. Ils permettent de fidéliser votre clientèle en la mettant en valeur et/ou en la captivant, tout en vous donnant l'opportunité d'atteindre de nouveaux clients. Je vous propose une formule à carte qui contiendra, en fonction d’une stratégie marketing développée ensemble, des contenus à partager de façon régulière avec vos clients.</p>
        </div>
        <div class="services__offres__line revealleft">
          <h3 class="services__offres__title">INFOGRAPHIE</h3>
          <p class="services__offres__text">Les infographies sont un des supports de communication les plus efficaces en marketing de contenu. C'est une représentation visuelle de données et d’informations, d'où son nom info-graphie. Elle combine plusieurs éléments (textes, graphiques, formes, images...) de façon lisible et agréable à regarder, tout en synthétisant le message à transmettre au public. Les infographies peuvent être utilisées dans de nombreuses occasions : pour reprendre une information, synthétiser des données, teaser un événement ou un produit, créer de la viralité sur les réseaux sociaux... Vous en croisez quotidiennement !</p>
        </div>
        <div class="services__offres__line revealright">
          <h3 class="services__offres__title">PHOTOS</h3>
          <p class="services__offres__text">Une image vaut mille mots ! Les photographies sont une pièce essentielle du marketing de contenu : elles permettent d'attirer l'attention de votre client, de le captiver et de générer des interactions et de la viralité. Elles permettent d'entretenir une relation de proximité avec votre clientèle, en montrant une image authentique de votre entreprise : nouveaux produits, travaux en cours, coulisses, saisonnalité... Les occasions ne manquent pas pour communiquer par la photographie ! LM Créations Numériques vous proposera une stratégie de contenu photographique, ainsi que leur réalisation avec la qualité pour priorité.</p>
        </div>
        <div class="services__offres__line revealleft">
          <h3 class="services__offres__title">VIDEOS</h3>
          <p class="services__offres__text">Les vidéos sont le contenu avec le potentiel viral le plus fort, qui peuvent vous permettre de toucher des milliers de clients potentiels. Les teasers, ou spots marketing très courts (moins de 30 secondes) règnent sur les réseaux sociaux, qu’ils soient en prises de vues réelles ou en motion design. Ils permettent de faire passer un message fort en allant droit au but et en incitant votre public à en voir plus. Plus longs, vous trouverez également des clips, films institutionnels, témoignages... à découvrir sur notre page vidéo !<router-link to="Videos">vidéos</router-link> !</p>
        </div>
        <div class="services__offres__line revealright">
          <h3 class="services__offres__title">MAILING</h3>
          <p class="services__offres__text">Le mailing consiste à envoyer des mails d'informations (plus connus sous le nom de newsletter) afin de prospecter mais aussi de fidéliser votre clientèle. Il faut tout d'abord collecter une base client avec leurs adresses email, tout en respectant le RGPD (Règlement Général sur la Protection des Données), pour ensuite leur envoyer les newsletters. Mais attention ! Il ne faut pas en abuser, au risque d'être considéré comme un spammeur. C'est pourquoi les newsletters doivent avoir un objectif marketing et une rédaction et des contenus soignés.</p>
        </div>
        <div class="services__offres__line revealleft">
          <h3 class="services__offres__title">CONTENT MANAGEMENT OU COMMUNITY MANAGEMENT ?</h3>
          <p class="services__offres__text">Il existe plusieurs types de marketing sur les réseaux sociaux, parmi eux, le content management et le community management. Le content management est la gestion des contenus publiés sur vos réseaux sociaux. Il ne faut pas le confondre avec le community management qui, lui, concerne à la fois la gestion des contenus et la gestion de votre communauté (modérer et répondre aux commentaires, aux messages…). Les offres que je vous propose sont du content management et du marketing de contenu. Mon rôle est de vous produire du contenu de qualité pour vos réseaux, suivant une stratégie marketing établie ensemble, tout en vous laissant l'autonomie de construire une relation de confiance avec vos abonnés. N'hésitez pas néanmoins à me demander des conseils !</p>
        </div>
        <div class="services__offres__line revealright">
          <h3 class="services__offres__title">CREATIONS NUMERIQUES</h3>
          <p class="services__offres__text">Pour les particuliers et même pour les professionnels, je propose également des créations numériques en tous genre comme la réalisation de photocollage de vos animaux en personnages médiévaux, l’intégration de sous-titres à vos vidéos, l’animation 2D de logo, etc. Vous trouverez ces prestations à la carte sur ComeUp (ex 5euros.com) mais aussi sur mesure en me contactant !</p>
        </div>
      </div> 
    </section>
    <section id="services__process" class="slideshow">
      <Creacontslideshow/>
    </section>
    <section id="services__price">
      <h2 class="services__title">LES TARIFS</h2>
    <Tarifscrea/>
    </section>
  </div>
</template>

<script>
import Creacontslideshow from '../components/creacontslideshow.vue';
import Creatext from '../components/creatext.vue';
import Tarifscrea from '../components/tarifscrea.vue';
import $ from 'jquery';
import AnchorRouterLink from 'vue-anchor-router-link'

export default {
  name: 'Home',
  components: {
    Creacontslideshow,
    AnchorRouterLink,
    Tarifscrea,
    Creatext
  },
  mounted() {
    /********** Apparition au scroll ****/
        var rafId = null;
        var delay = 230;
        var lTime = 0;

        function scroll() {
          var scrollTop = $(window).scrollTop();
          var height = $(window).height()
          var visibleTop = scrollTop + height;
          $('.revealleft').each(function() {
            var $t = $(this);
            if ($t.hasClass('reveal_visible')) { return; }
            var top = $t.offset().top;
            if (top <= visibleTop) {
              if (top + $t.height() < scrollTop) {
                $t.removeClass('reveal_pending').addClass('reveal_visible');
              } else {
                $t.addClass('reveal_pending');
                if (!rafId) requestAnimationFrame(reveal);  
              }
            }
          });
          $('.revealright').each(function() {
            var $t = $(this);
            if ($t.hasClass('reveal_visible')) { return; }
            var top = $t.offset().top;
            if (top <= visibleTop) {
              if (top + $t.height() < scrollTop) {
                $t.removeClass('reveal_pending').addClass('reveal_visible');
              } else {
                $t.addClass('reveal_pending');
                if (!rafId) requestAnimationFrame(reveal);  
              }
            }
          });
        }
        function reveal() {
          rafId = null;
          var now = performance.now();
          
          if (now - lTime > delay) {
            lTime = now;
            var $ts = $('.reveal_pending');
            $($ts.get(0)).removeClass('reveal_pending').addClass('reveal_visible');  
          }
          
          
          if ($('.reveal_pending').length >= 1) rafId = requestAnimationFrame(reveal);
        }

        $(scroll);
        $(window).scroll(scroll);
  }
}
</script>

<style lang="scss">

/******************** CARTES HAUT DE PAGE */

.services__card {
    background-image: url('../assets/wavej4.svg');
    background-size: auto;
    background-position-y: center;
    background-repeat: repeat-x;
    padding-top: 100px;
    padding-bottom: 80px;
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
  @media screen and (max-width: 980px){
            background-size: cover;
            flex-direction: column;
            padding-top: 50px;
            padding-bottom: 0;
            }
  &__container {
  display: flex;
  justify-content: space-evenly;
  box-sizing: border-box;
  width: 80%;
  margin: auto;
  }
  &__one {
    width: 25%;
    box-shadow: 0px 0px 6px 0px grey;
    border-radius: 50px;
    align-items: center;
    display: flex;
    flex-direction: column;
    padding: 50px 20px;
    box-sizing: border-box;
    transition: all 0.25s;
    backdrop-filter: blur(15px);
    -webkit-backdrop-filter: blur(15px);
    z-index: 50;
    //background: linear-gradient(127deg, #ffffff66 0%, #1967a314 90%, #ffffff66 110%);
    &:hover {
      transform: scale(1.03) skewY(13deg);
    }
    @media (max-width: 980px) {
      width: 90%;
      margin: auto;
      margin-bottom: 50px;
    }
    @media (min-width: 1440px) {
      padding: 50px 50px;
    }
    &__center {
       width: 25%;
    box-shadow: 0px 0px 6px 0px grey;
    border-radius: 50px;
    align-items: center;
    display: flex;
    flex-direction: column;
    padding: 50px 20px;
    box-sizing: border-box;
    transition: all 0.25s;
    backdrop-filter: blur(15px);
    -webkit-backdrop-filter: blur(15px);
    z-index: 50;
    //background: linear-gradient(127deg, #ffffff66 0%, #1967a314 90%, #ffffff66 110%);
      &:hover {
      transform: scale(1.03) skewY(-13deg);
    }
    @media (max-width: 980px) {
      width: 90%;
      margin: auto;
      margin-bottom: 50px;
      transform: skewY(13deg)!important;
      &:hover {
      transform: scale(1.03) skewY(13deg);
        }
      }
     @media (min-width: 1440px) {
      padding: 50px 50px;
    }
    }
  }
  &__title {
    font-family: 'Yanone Kaffeesatz', sans-serif;
    font-size: xx-large;
    text-align: center;
  }
  &__icon {
  font-size: 400%;
  background: linear-gradient(308deg, #1c09e0cf 0%, #38e01fc7 100%);
  background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 20px;
  }
}

.skewleft {
  transform: skewY(13deg);
  display: flex;
    flex-direction: column;
    align-items: center;
}

.skewright {
  transform: skewY(-13deg);
  display: flex;
    flex-direction: column;
    align-items: center;
}

.center {
   @media (max-width: 980px) {
      transform: skewY(-13deg)!important;
   }
}

/********************* INTRO SUR IMAGE HAUT DE PAGE */

.maintitle {
  font-family: 'Yanone Kaffeesatz', sans-serif;
  font-size: 8vw;
  color: white;
  margin-bottom: 0;
  @media (max-width: 1440px) {
		font-size: 8vw;
	}
  @media (max-width: 1024px) {
		font-size: 10vw;
	}
  @media (max-width: 768px) {
		font-size: 10vw;
	}
  @media (max-width: 425px) {
		font-size: 10vw;
	}
  @media (max-width: 300px) {
		font-size: 10vw;
	}
}

#homehead {
  width: 80%;
  margin: auto;
  height: 73vh;
}

.maintext {
  font-family: 'Open Sans', sans-serif;
  color: white;
  width: 60%;
  border-top: 6px solid white;
  padding-top: 24px;
  @media (max-width: 1440px) {
		font-size: medium;
    width: 60%;
	}
  @media (max-width: 1024px) {
		font-size: medium;
    width: 80%;
	}
  @media (max-width: 768px) {
		font-size: small;
    width: 80%;
	}
  @media (max-width: 425px) {
		font-size: small;
    width: 80%;
	}
  @media (max-width: 300px) {
		font-size: small;
    width: 80%;
	}
}

/********************* BLOC OFFRES */


#services__offres {
  position: relative;
  width: 100%;
  margin: auto;
  height: 6000px;
  @media (max-width: 769px) {
    width: 95%;
    height: auto;
	}
  @media only screen and (min-device-width : 769px) and (max-device-width : 1024px) and (orientation : portrait) {
    width: 95%;
    height: auto;
  }
}


.sticky {
  position: sticky;
  display: flex;
  top: 50%;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
  width: 100%;
  background-image: url('../assets/wave2j1.svg');
  background-size: auto;
  background-position-y: center;
  background-repeat: repeat-x;
  -webkit-transform: translate(0,-50%);
  transform: translate(0,-50%);
  margin-top: 30%;
  margin-bottom: -10%;
  @media screen and (max-width: 769px){
            display: none;
            }
  @media only screen and (min-device-width : 769px) and (max-device-width : 1024px) and (orientation : portrait) {
    display: none;
  }
  &__img {
    width: 40%;
  }
  &__no {
    width: 90%;
    margin: auto;
        display: flex;
    flex-direction: column;
    margin-bottom: 50px;
    overflow: hidden;
    @media screen and (min-width: 769px){
            display: none;
            }
    @media only screen and (min-device-width : 770px) and (max-device-width : 1024px) and (orientation : portrait) {
    width: 90%;
    margin: auto;
        display: flex;
    flex-direction: column;
    margin-bottom: 50px;
    overflow: hidden; ;
    }
  }
}

.services__offres {
  &__title {
        font-family: 'Yanone Kaffeesatz', sans-serif;
        font-size: 40px;
        margin-top: 30px;
        margin-bottom: 10px;
        position: relative;
        width: 100%;
        text-align: left;
        &::before {
        content: '';
        width: 100%;
        position: absolute;
        left: 0;
        top: calc( 50% - 1.5px );
        border-bottom: 20px solid #38e01f;
        z-index: -1;
        }
        @media screen and (max-width: 980px){
                margin-top: 60px;
                }
    }
    &__text {
      font-size: small;
      text-align: left;
    }
    &__img {
      width: 90%;
      margin: auto;
    margin-top: 20px;
    }

}

/****************** BLOC PRIX */

#services__price {
  width: 100%
}

 .services__title {
    font-family: 'Yanone Kaffeesatz', sans-serif;
    font-size: 70px;
    margin-top: 0;
    margin-bottom: 30px;
    position: relative;
    width: 90%;
    margin: auto;
    &::before {
      content: '';
    width: 100%;
    position: absolute;
    left: 0;
    top: calc( 50% - 1.5px );
    border-bottom: 30px solid #38e01f;
    z-index: -1;
    }
    @media screen and (max-width: 980px){
            margin-top: 60px;
            }
  }

/********************* APPARITION AU SCROLL */

.revealleft {
  opacity: 0;
  transform: translate3d(-100px, 0, 0);
  transition: opacity 0.8s, transform 0.8s;
}

.revealright {
  opacity: 0;
  transform: translate3d(100px, 0, 0);
  transition: opacity 0.8s, transform 0.8s;
}

.reveal_visible {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
</style>
